import { FC, useEffect, useState } from 'react';
import PageTitle from 'components/PageTitle';
import Layout from 'layouts/Layout';
import Panel from 'components/Panel';
import Table from 'components/Table';
import Forbidden from 'pages/forbidden';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { newPermissionGroupsPath, editPermissionGroupsPathCreator } from 'routes/permissionGroups/path';
import { getPermissionGroups, PermissionGroup } from 'libs/apiClient/admin/permissionGroups';

const Index: FC = () => {
  const history = useHistory();
  const [permissionGroups, setPermissionGroups] = useState<PermissionGroup[]>([])
  const [isForbidden, setIsForbidden] = useState<Boolean>(false);

  useEffect(() => {
    const forbiddenCallback = () => { setIsForbidden(true); }

    getPermissionGroups(setPermissionGroups, forbiddenCallback);
  }, []);

  const Page = () => {
    return (
      <Layout>
        <PageTitle title="権限グループ一覧">
          <Button onClick={() => history.push(newPermissionGroupsPath)}>新規追加</Button>
        </PageTitle>

        <Panel>
          <Table>
            <thead>
              <tr>
                <th>ID</th>
                <th>名前</th>
                <th>説明</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {
                permissionGroups?.map(permissionGroup => {
                  return (
                    <tr key={permissionGroup.id}>
                      <td className="align-middle">{permissionGroup.id}</td>
                      <td className="align-middle">{permissionGroup.name}</td>
                      <td className="align-middle">{permissionGroup.description}</td>
                      <td className="align-middle">
                        <Button variant='dark' onClick={() => history.push(editPermissionGroupsPathCreator(permissionGroup.id))}>編集</Button>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Panel>
      </Layout>
    )
  }

  if (isForbidden) {
    return <Forbidden />;
  } else {
    return Page();
  }
}

export default Index;